import radio from '@/lib/radio.js'
import { filterImages } from '@/components/product.js'
import { formatMoney } from '@/lib/currency.js'

export default function productSelection (node, opts) {
  opts = Object.assign({
    select: '[data-option-select]',
    radio: '[data-option-radio]',
    main: '[data-option-main]',
  }, opts)

  const listeners = []

  const state = {
    id: null,
    options: [] // This stores an array of the selected options
  }

  let selects = slater.qsa(opts.select);
  let radios = slater.qsa(opts.radio);
  let main = slater.qs(opts.main);

  let variants = [].slice.call(main.children).reduce((variants, child) => {
    variants[child.innerHTML] = child.value;
    return variants;
  }, {});

  const $colorRadio = $('.js-color-select');
  const $formRadios = $('.js-option-radio');
  const $mainSelects = $('.js-main-select');
  const $productJsons = $('.js-product-json');
  const $productInventoryJsons = $('.js-product-inventory-json');
  const $allInputSet = $('.js-input-set');
  const $prodImages = $('.js-product-image');
  const $productPrice = $('.js-product-price');
  const $comparePrice = $('.js-compare-price');
  const $features = $('.js-toggle-feature');
  const $addToCart = $('.js-add-to-cart');

  let product = JSON.parse($('[data-product-json]').html());
  let productInventory = JSON.parse($('[data-inventories-json]').html());

  let quantityBlock = $('.js-product-form-quantity-left');
  let quantityBlockNumber =  $('.js-product-form-quantity-left-number');
  let limitThreshold = 0;

  if (quantityBlock){
     limitThreshold = quantityBlock.attr('data-threshold-limit');
  }

  // New Fmas Update #1 17-June-21 start
  var genderTabValue = 'mens'; //Storing selected gender value
  // New Fmas Update #1 17-June-21 end

  //Color select
  $colorRadio.on('change', function() {

    // New Fmas Update #2 17-June-21 start
      $('.js-gender-tab.js-tab').removeClass('active'); //Removing all active class in gender tab
      $('.js-gender-tab.js-tab[data-tab-gender=' + genderTabValue + ']').addClass('active'); //Adding active class for selected gender in gender tab
    // New Fmas Update #2 17-June-21 end

    const val = $(this).val();
    const color = $(this).attr('data-color');
    const imageLength = $(this).attr('data-image-length');
    const $optionSet = $('[data-input-set-color="' + color + '"]');
    const $colorOption = $optionSet.find('[data-option="color"] input');
    const $activeSelect = $('.js-main-select[data-select-color="' + color + '"]');
    const $activeJson = $('[data-json-color="' + color + '"]');
    const $activeInventoryJson = $('[data-json-color-inventories="' + color + '"]');
    const $activeImages = $('[data-image-color="' + color + '"]');
    const $imageLength = $('.js-image-length');
    const $activeColorName = $('.js-option-name');
    const $activeFeatures = $('.js-toggle-feature[data-color="' + color + '"]');
    const $finalSale = $('.js-final-sale');
    const $finalSaleProp = $('.js-final-sale-property');
    const $deisgnerCallout = $('.js-designer-callout');
    const gender = $('.js-product-images').attr('data-gender');
    const $activePopupTitle = $('.js-color-title');

    const inputActive = 'product-input--active';
    const finalSaleTag = 'final_sale';
    const designerTag = 'designer_';

    product = JSON.parse($activeJson.html());
    productInventory = JSON.parse($activeInventoryJson.html());
    const price = formatMoney(product.price_min).toString().replace('.00', '');
    const comparePrice = formatMoney(product.compare_at_price_max).toString().replace('.00', '');

    //Remove active state for product JSON
    $productJsons.removeAttr('data-product-json');
    $productInventoryJsons.removeAttr('data-inventories-json');
    
    //Remove active state on all input groups & inputs
    $allInputSet.removeClass(inputActive);
    $optionSet.addClass(inputActive);
    $formRadios.removeAttr('data-option-radio');

    //Remove active state from main variant select
    $mainSelects.removeAttr('name');
    $mainSelects.removeAttr('data-option-main');

    //Set active inputs
    $optionSet.find('.js-option-radio').attr('data-option-radio', '');
    $activeSelect.attr('name', 'id');
    $activeSelect.attr('data-option-main', '');

    if ($colorOption.length) {
      $colorOption.prop('checked', true).trigger('change');
    }

    //Update price
    if (product.compare_at_price_max > product.price_min) {
      $comparePrice.html(comparePrice);
      $productPrice.html(price);

      $productPrice.addClass('on-sale');
      $comparePrice.addClass('active');
    }
    else {
      $productPrice.html(price);

      $productPrice.removeClass('on-sale');
      $comparePrice.removeClass('active');
    }

    $productPrice.html(price);

    let isFinalSale = false;
    let designer = false;

    for (i=0;i<product.tags.length;i++) {
      //Final sale tag
      if (product.tags[i] == finalSaleTag) {
        isFinalSale = true;
      }
      //Designer tag
      if (product.tags[i].indexOf(designerTag) >= 0) {
        designer = product.tags[i].split('designer_')[1].replace('-', ' ');
      }
    }

    if (isFinalSale) {
      $finalSale.addClass('active');
      $finalSaleProp.val('Yes');
      $finalSaleProp.prop('disabled', false);
    }
    else {
      $finalSale.removeClass('active');
      $finalSaleProp.val('No');
      $finalSaleProp.prop('disabled', true);
    }

    if ($deisgnerCallout.length) {
      if (designer && designer != '') {
        $deisgnerCallout.text('by ' + designer);
        $deisgnerCallout.addClass('active');
      }
      else {
        $deisgnerCallout.removeClass('active');
      }
    }

    //Set active json
    $activeJson.attr('data-product-json', '');
    $activeInventoryJson.attr('data-inventories-json', '');
    
    //Swap/filter product images
    $prodImages.removeClass('active');

    if ($activeImages.length) {

      $activeImages.each(function() {
        const imgGender = $(this).attr('data-gender');
        if (typeof imgGender !== typeof undefined && imgGender !== false) {
          if (gender == imgGender) {
            $(this).addClass('active');
          }
        }
        else {
          $(this).addClass('active');
        }
      });
      filterImages(gender);
    }

    //Product features
    $features.removeClass('active');
    $activeFeatures.addClass('active');

    //Set active color name
    $activeColorName.text(val);
    $activePopupTitle.text(val);

    //Set new URL
    const url = window.location.href.split('products/')[0];
    const nextURL = url + 'products/' + product.handle;
    const nextTitle = product.title + ' - YORK Athletics Mfg.'
    const nextState = { additionalInformation: nextTitle };

    window.history.replaceState(nextState, nextTitle, nextURL);

    //Get new variants array
    main = slater.qs(opts.main);
    variants = [].slice.call(main.children).reduce((variants, child) => {
      variants[child.innerHTML] = child.value;
      return variants;
    }, {});


    // New Fmas Update #3 17-June-21 start
    //Highlight size on color change start
    let selectedGenderTextOnPageOnly = localStorage.getItem("selectedGenderTextOnPageOnly");
    let sizeInNumberTemp = localStorage.getItem("sizeInNumberTemp");
    var selectedSizeElement = $('.product-input--active .product__sizes.js-gender-tab-content span[data-gender=' + selectedGenderTextOnPageOnly + ']:contains(' + sizeInNumberTemp + '):first');
    selectedSizeElement.parent().find('input').prop('checked', true).trigger('change');
    //Highlight size on color change end
    // New Fmas Update #3 17-June-21 end

    //Trigger scroll event to fire lazyloading images
    $(window).trigger("scroll");
  });


  // New Fmas Update #4 17-June-21 start
  $('.size').click(function(){
    var menSize = jQuery(this).find("[data-gender=mens]").text();
    var womenSize = jQuery(this).find("[data-gender=womens]").text();
    let selectedGenderTextOnPageOnly = localStorage.getItem("selectedGenderTextOnPageOnly");
    if($.isNumeric(menSize) && selectedGenderTextOnPageOnly == 'mens'){
      localStorage.setItem("sizeInNumberTemp", menSize);
    }
    else if($.isNumeric(womenSize) && selectedGenderTextOnPageOnly == 'womens'){
      localStorage.setItem("sizeInNumberTemp", womenSize);
    }
  });

  // Updating selected gender tab value
  $('.js-gender-tab.js-tab').click(function(){
    let gender = $(this).attr('data-tab-gender');
    genderTabValue = gender;
  });
  // New Fmas Update #4 17-June-21 end


  if (!main || !main.length) throw 'data-option-main is missing'
  if (radios.length > 3) throw 'you have more than three radio groups'
  if (selects.length > 3) throw 'you have more than three select inputs'

  selects.forEach(select => {
    if (select.nodeName !== 'SELECT') throw 'data-option-select should be defined on the individual option selectors'

    const index = parseInt(select.getAttribute('data-index'))

    // set initial value
    state.options[index] = select.value

    select.addEventListener('change', e => {
      state.options[index] = e.target.value
      updateSelection()
    })
  });

  $('.product').on('change', '[data-option-radio] input[type="radio"]', function() {
    const val = $(this).val();
    const index = parseInt($(this).closest('[data-option-radio]').attr('data-index'));
    state.options[index] = val;
    updateSelection();
  });

  //Collect values on page load
  $formRadios.each(function() {
    const $radioInput = $(this).find('input');
    const val = $radioInput.val();
    const index = parseInt($(this).attr('data-index'));

    if ($radioInput.is(":checked")) {
      state.options[index] = val;
    }
  });

  updateSelection();

  // Join options into string that matches up with the main select box value
  function updateSelection () {
    const optionString = state.options.join(' / ').replace('&', '&amp;');
    state.id = variants[optionString];

    console.log(state);

    const variant = product.variants.filter(v => v.id === parseInt(state.id))[0];

    updateAddToCartState(variant);

    updatePrices(variant);

    $('[data-option-main]').val(state.id);
    for (let fn of listeners) fn(state)
  }

  function updatePrices(variant) {
    if (variant) {
      const price = variant.price;
      const comparePrice = variant.compare_at_price;

      const priceMoney = formatMoney(price).toString().replace('.00', '');
      const comparePriceMoney = formatMoney(comparePrice).toString().replace('.00', '');

      if (comparePrice > price) {
        $comparePrice.html(comparePriceMoney);
        $productPrice.html(priceMoney);

        $productPrice.addClass('on-sale');
        $comparePrice.addClass('active');
      }
      else {
        $productPrice.html(priceMoney);

        $productPrice.removeClass('on-sale');
        $comparePrice.removeClass('active');
      }
    }
  }

  function updateAddToCartState(variant) {

    if (variant) {
      let variantQuantity = productInventory[variant.id];

      if (limitThreshold){
        if (variantQuantity > 0 && variantQuantity < limitThreshold){
          quantityBlock.removeClass('hidden');
          quantityBlockNumber.html(variantQuantity)
        }else{
          quantityBlock.addClass('hidden');
        }
      }

      const soldOutString = $addToCart.attr('data-sold-out');
      const availString = $addToCart.attr('data-available');
      let klaviyoOutofstock = $('.back-in-stock-trigger');

      if (variant.available) {
        $addToCart.removeClass('hidden');
        klaviyoOutofstock.addClass('hidden');
        $addToCart.prop('disabled', false);
        $addToCart.text(availString);

      } else {
        $addToCart.addClass('hidden');
        klaviyoOutofstock.removeClass('hidden');
        $addToCart.prop('disabled', true);
        $addToCart.text(soldOutString);
        $('.js-bis-variant-title').val(variant.title);
      }
    }
  }

  return {
    get state () {
      return state
    },
    onUpdate (fn) {
      listeners.indexOf(fn) < 0 && listeners.push(fn)
      return () => listeners.splice(listeners.indexOf(fn), 1)
    }
  }
}
